export default {
  IS_LOGIN: 'isLogin',
  HAS_ROLE: 'hasRole',
  YEARS_TYPES: 'yearsTypes',
  YEARS_TYPES_DISPLAY: 'yearsTypesDisplay',
  ACTIVE_YEARS_TYPES: 'activeYearsTypes',
  ORG_YEARS: 'orgYears',
  OPTIONS_USER_DATA: 'Options_user_data',
  IS_LOADING: 'isLoading',
  OPTIONS_CONTENT_DATA: 'optionsContent',
  S3_ACTIVE: 's3Active',
  AUDITS_INPUT_DATA: 'auditsInputData',
  AUDITS_ORG: 'auditsOrg',
  AUDITS_DATA: 'auditsData',
  PREFIX_SAVEON_TIME: 'Last Saved on',
  CHECK_OPTIONS_STATE: 'CHECK_OPTIONS_STATE',
  TERMS_DATA: 'termsData',
  API_ERROR: 'apiError',
};
